<section class="contact-form" [appReveal]>
  <p class="contact-form__eyebrow" i18n="@@contactForm.eyebrow">聯絡表格 Contact Form</p>

  <p class="contact-form__intro" i18n="@@contactForm.intro">
    我們致力為客人提供優質的食品及服務，歡迎客人提供寶貴意見，讓我們能夠做得更好。
  </p>
  <p class="contact-form__sub" i18n="@@contactForm.sub">如有任何業務、合作查詢，歡迎跟我們聯絡。</p>

  <form class="contact-form__fields" (ngSubmit)="onSubmit()" novalidate>
    <div class="contact-form__field">
      <label class="contact-form__label" for="contact-name"><ng-container i18n="@@contactForm.name.label">姓名</ng-container> <span class="contact-form__required">*</span></label>
      <input
        id="contact-name"
        type="text"
        class="contact-form__input"
        [class.contact-form__input--invalid]="isFieldInvalid('name')"
        i18n-placeholder="@@contactForm.name.placeholder"
        placeholder="請輸入您的姓名"
        [(ngModel)]="model.name"
        name="name"
        [disabled]="isSubmitting"
        autocomplete="name">
    </div>

    <div class="contact-form__field">
      <label class="contact-form__label" for="contact-email"><ng-container i18n="@@contactForm.email.label">電郵地址</ng-container> <span class="contact-form__required">*</span></label>
      <input
        id="contact-email"
        type="email"
        class="contact-form__input"
        [class.contact-form__input--invalid]="isFieldInvalid('email')"
        i18n-placeholder="@@contactForm.email.placeholder"
        placeholder="請輸入您的電郵地址"
        [(ngModel)]="model.email"
        name="email"
        [disabled]="isSubmitting"
        autocomplete="email">
    </div>

    <div class="contact-form__field">
      <label class="contact-form__label" for="contact-phone" i18n="@@contactForm.phone.label">聯絡電話</label>
      <input
        id="contact-phone"
        type="tel"
        class="contact-form__input"
        i18n-placeholder="@@contactForm.phone.placeholder"
        placeholder="請輸入您的聯絡電話"
        [(ngModel)]="model.phone"
        name="phone"
        [disabled]="isSubmitting"
        autocomplete="tel">
    </div>

    <div class="contact-form__field">
      <label class="contact-form__label" for="contact-subject"><ng-container i18n="@@contactForm.subject.label">主題</ng-container> <span class="contact-form__required">*</span></label>
      <input
        id="contact-subject"
        type="text"
        class="contact-form__input"
        [class.contact-form__input--invalid]="isFieldInvalid('subject')"
        i18n-placeholder="@@contactForm.subject.placeholder"
        placeholder="請輸入查詢主題"
        [(ngModel)]="model.subject"
        name="subject"
        [disabled]="isSubmitting">
    </div>

    <div class="contact-form__field">
      <label class="contact-form__label" for="contact-message"><ng-container i18n="@@contactForm.message.label">訊息</ng-container> <span class="contact-form__required">*</span></label>
      <textarea
        id="contact-message"
        class="contact-form__textarea"
        [class.contact-form__input--invalid]="isFieldInvalid('message')"
        i18n-placeholder="@@contactForm.message.placeholder"
        placeholder="請輸入您的訊息"
        [(ngModel)]="model.message"
        name="message"
        [disabled]="isSubmitting"></textarea>
    </div>

    <p class="contact-form__feedback contact-form__feedback--success" *ngIf="hasSuccess" i18n="@@contactForm.success">
      訊息已成功送出，我們會盡快回覆您。Thank you — we'll be in touch.
    </p>
    <p class="contact-form__feedback contact-form__feedback--error" *ngIf="hasError" i18n="@@contactForm.error">
      抱歉，提交失敗，請稍後再試。Sorry, something went wrong. Please try again.
    </p>

    <button
      type="submit"
      class="contact-form__submit"
      [disabled]="isSubmitting">
      <span *ngIf="!isSubmitting" i18n="@@contactForm.submit">提交 Submit</span>
      <span *ngIf="isSubmitting" i18n="@@contactForm.submitting">提交中… Sending…</span>
    </button>
  </form>
</section>
